import React, { useState } from 'react';
import Iconify from '../../../../Iconify';
import styles from './instructions.module.css';

export const InstructionsStore = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClose = () => {
    setIsExpanded(false);
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.triggerButton}
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <span className={styles.triggerText}>¿Cómo hacer el pago?</span>
        <Iconify
          icon={isExpanded ? 'material-symbols:keyboard-arrow-up' : 'material-symbols:keyboard-arrow-down'}
          className={styles.triggerIcon}
        />
      </button>

      {isExpanded && (
        <div className={styles.instructionsContainer}>
          <div className={styles.instructionsContent}>
            <h3 className={styles.instructionsTitle}>Instrucciones para realizar la transferencia</h3>
            
            <ol className={styles.stepsList}>
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>1</span>
                <span className={styles.stepText}>
                  Imprime tu referencia o llévala en tu celular a cualquiera de las tiendas participantes.
                </span>
              </li>
              
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>2</span>
                <span className={styles.stepText}>
                  Entrega tu referencia al cajero, realiza tu pago y guarda tu comprobante.
                </span>
              </li>
              
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>3</span>
                <span className={styles.stepText}>
                  En cuestión de horas verás tu saldo abonado.
                </span>
              </li>
            </ol>
          </div>

          <button
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Cerrar instrucciones"
          >
            <span className={styles.closeButtonText}>Cerrar instrucciones</span>
            <Iconify icon="material-symbols:close" className={styles.closeButtonIcon} />
          </button>
        </div>
      )}
    </div>
  );
};
